
class SwiperContainer extends HTMLElement {
	constructor() {
		super();

		this.defaultSettings = {
			updateOnWindowResize: true,
			watchOverflow: true,
			on: {
				init: this.onInit.bind(this),
				destroy: this.onDestroy.bind(this)
			},
		};
	}

	connectedCallback() {
		this.breakpoint = this.dataset.breakpoint;
		this.breakpointMediaQuery = window.matchMedia(this.breakpoint);

		this.createInstance();

	}

	createInstance() {
		try {
			const settings = this.dataset.settings;

			this.settingsJSON = settings ? JSON.parse(settings) : {};
			this.swiper = new Swiper(this, Object.assign({}, this.settingsJSON, this.defaultSettings));
		} catch (error) {
			throw new Error(`Failed to create swiper instance: ${this}; Error description: ${error}`);
		}
	}

	onInit(swiper) {
		if (this.breakpoint) {
			this.onBreakpointEnable(this.breakpointMediaQuery);
			this.breakpointMediaQuery.addEventListener('change', this.onBreakpointEnable.bind(this));
		}
	}

	onDestroy(swiper) {
		this.breakpointMediaQuery.removeEventListener('change', this.onBreakpointEnable.bind(this));
	}

	/*
	* Example of usage: data-breakpoint="(max-width: 767px)"
	* */
	onBreakpointEnable(breakpoint) {
		if (breakpoint.matches) {
			if (!this.swiper || this.swiper.destroyed) this.createInstance();
		} else {
			if (this.swiper) this.swiper.destroy(true, true);
		}
	}
}

if (!customElements.get('swiper-container')) {
	customElements.define('swiper-container', SwiperContainer);
}